import React from 'react';

export const FlexRowSpace = (props: {}) => {
  return <span style={{ flex: 1 }} />;
};
